module.exports = __webpack_public_path__ + "img/beneficios-02.1a8cff71.png";